<template>
  <div>
    <!-- Dialog -->
    <el-dialog title="批量升级" :append-to-body="true"  :close-on-click-modal="false" :visible.sync="BatchUpGradeDialogFlag" width="30%" :before-close="cancle">
      <el-form :model="updateForm" :rules="updateRules" ref="updateForm" :validate-on-rule-change="false" center>
        <el-form-item label="待升级版本号" prop="sourceVersions">
          <el-select
            v-model="updateForm.sourceVersions"
            :multiple = "true"
            @change="versionChange"
            filterable
            allow-create
            default-first-option
            style="width:100%"
            :disabled="rows.firmwareType=== 1 ? true: false"
            placeholder="请选择版本号">
            <el-option
              v-for="item in sourceVersionsOptions"
              :key="item.moduleVersion"
              :label="item.moduleVersion"
              :value="item.moduleVersion">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级策略"  prop="strategyType">
          <el-select
            v-model="updateForm.strategyType"
            @change="strategyTypeChange"
            style="width:100%"
            placeholder="请选择升级策略">
            <el-option
              v-for="item in strategyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级范围" prop="upgradeScope">
          <el-select
            v-model="updateForm.upgradeScope"
            @change="upgradeScopeChange"
            style="width:100%"
            placeholder="请选择升级范围">
            <el-option
              v-for="item in upgradeScopeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级方式" :required="true"  v-if="updateForm.upgradeScope === 1 ">
          <el-radio-group v-model="radioType">
            <el-radio :label="0">手动选择</el-radio>
            <el-radio :label="1">文件上传</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设备范围" prop="deviceList" v-if="updateForm.upgradeScope === 1 && radioType === 0">
          <el-select
            :multiple="true"
            v-model="updateForm.deviceList"
            style="width:100%"
            ref="deviceScope"
            @focus="focusStatus&&openDrawer()"
            placeholder="请选择设备范围">
            <el-option
              v-for="item in deviceListOptions"
              :key="item.id"
              :label="item.deviceName"
              :value="item.productKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择文件" v-if="updateForm.upgradeScope === 1 && radioType === 1" prop="file" :rules="[{ required: true, validator: file, trigger: 'change' }]">
          <el-upload
            ref="upload"
            name="file"
            action="bb"
            :http-request="fileRequest"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :on-remove="handleRemove"
            accept=".xls,.xlsx"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <el-row :gutter="10" class="text" v-if="flag">
            <el-col :span="6" style="padding-left:15px" @click.native="handlerClick('text')">查看问题描述</el-col>
            <el-col :span="8" @click.native="handlerClick('fileList')">查看成功上传设备</el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="是否强制升级" prop="upgradeTimeType" :required="true">
          <el-radio-group v-model="updateForm.isForceUpgrade">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="升级时间类型" prop="upgradeTimeType">
          <el-select
            v-model="updateForm.upgradeTimeType"
            style="width:100%"
            placeholder="请选择升级时间类型">
            <el-option
              v-for="item in upgradeTimeTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 判断为定时升级才显示这一栏  -->
        <el-form-item label="升级开始时间" prop="upgradeTime" v-if="updateForm.upgradeTimeType === 1">
          <el-date-picker
            style="width:100%"
            v-model="updateForm.upgradeTime"
            type="datetime"
            :picker-options="pickerOptions"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="升级超时时间(分)" prop="upgradeTimeout">
          <el-input  v-model.number="updateForm.upgradeTimeout"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="btn-grounp">
          <el-button @click="cancle">取 消</el-button>
          <el-button type="primary" @click="confirm('updateForm')">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <Drawer
    v-if="drawerFlag"
    ref="drawer"
    :ids="ids"
    :popData="rows"
    :vValue="vValue"
    :popDate="date"
    :drawerFlag="drawerFlag"
    :versionOptions="sourceVersionsOptions"
    @closeDrawer="closeDrawer"
    @getChildData="getChildData"></Drawer>
    <TextDialog v-if="textDialog" :textDialog="textDialog" :textDesc="textDesc" @closeText="textDialog = false"/>
    <FileList v-show="fileListDialog" :fileListDialog="fileListDialog" :deviceDetail="deviceDetail" @closeFileDrawer="fileListDialog = false"/>
  </div>
</template>
<script>
import Drawer from '@/components/VerifyFirmwareDialog/drawer.vue'
import TextDialog from '@/components/VerifyFirmwareDialog/textDescDialog.vue'
import FileList from '@/components/VerifyFirmwareDialog/uploadDeviceList.vue'
import { getVersions, add, isExistStrategy, importFile } from '@/api/productControl.js'
import { v4 as uuidv4 } from 'uuid'
export default {
  props: {
    BatchUpGradeDialogFlag: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Object
    },
    date: {
      type: Number
    }
  },
  data () {
    const checkStra = (rule, value, callback) => {
      if (this.updateForm.strategyType === 1) {
        const params = {
          params: {
            firmwareId: this.rows.firmwareId
          }
        }
        isExistStrategy(params).then(res => {
          if (res.data.data.exist === 1) {
            return callback(new Error('该固件下已有全量升级批次，不可重复创建'))
          } else {
            callback()
          }
        })
      } else {
        callback()
      }
    }
    const checkUptime = (rule, value, callback) => {
      if (this.updateForm.upgradeTimeout > 1440 || this.updateForm.upgradeTimeout < 0 || isNaN(this.updateForm.upgradeTimeout)) {
        return callback(new Error('请输入1-1440之间的整数'))
      } else {
        callback()
      }
    }
    const verifyTime = (rule, value, callback) => {
      if (this.updateForm.upgradeTime < Date.now()) {
        return callback(new Error('升级开始时间必须大于当前时间'))
      } else {
        callback()
      }
    }
    return {
      radioType: 0,
      fileList: [],
      flag: false,
      deviceDetail: [], // 上传文件列表
      textDesc: null, // 上传文件错误描述
      textDialog: false, // 描述弹窗开关
      fileListDialog: false, // 设备弹窗开关
      // dialogFormVisible: false, // 批量升级
      sourceVersionsOptions: [], // 版本号
      strategyTypeOptions: [
        {
          label: '灰度升级',
          value: 0 // 0
        },
        {
          label: '全量升级',
          value: 1 // 1  TODO: 需做判断处理
        }
      ],
      deviceListOptions: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      updateForm: {
        sourceVersions: [], // 待升级版本
        strategyType: 0, // 升级策略
        upgradeScope: '', // 升级范围
        deviceList: [], // 设备范围
        upgradeTimeType: 0, // 升级时间类型
        upgradeTime: '', // 升级开始时间
        upgradeTimeout: '', // 升级超时时间
        isForceUpgrade: 0
      },
      updateRules: {
        sourceVersions: [
          { required: true, message: '请选择待升级版本', trigger: 'change' }
        ],
        strategyType: [
          { required: true, message: '请选择升级策略', trigger: 'change' },
          { validator: checkStra, trigger: 'change' }
        ],
        upgradeScope: [
          { required: true, message: '请选择升级范围', trigger: 'change' }
        ],
        deviceList: [
          { required: true, message: '请选择设备范围', trigger: 'change' }
        ],
        upgradeTimeType: [
          { required: true, message: '请选择升级时间类型', trigger: 'change' }
        ],
        upgradeTime: [
          { required: true, message: '请选择升级开始时间', trigger: 'change' },
          { validator: verifyTime, trigger: 'change' }
        ],
        upgradeTimeout: [
          { validator: checkUptime, trigger: 'blur' }
        ]
      },
      focusStatus: true,
      ids: [], // 传给子组件,
      drawerFlag: false,
      vValue: []
    }
  },
  watch: {
    'updateForm.sourceVersions': {
      deep: true,
      handler (val, old) {
        this.vValue = Object.assign([], val)
        if (val.length < old.length) {
          const differ = this.getArrDifference(val, old)// differ[0]则是那个不同的值
          console.log('daviceList', this.updateForm.deviceList)
          // TODO: 需将val跟old中的差值取出来进行删除
          this.deviceListOptions = this.deviceListOptions.filter((ele, index) => {
            console.log(ele, differ)
            return ele.deviceVersion !== differ[0]
          })
          console.log('deviceOptions', this.deviceListOptions)
          const deviceNameLists = []
          this.deviceListOptions.forEach(element => {
            deviceNameLists.push(element.deviceName)
          })
          this.updateForm.deviceList = deviceNameLists
        }
      }
    },
    focusStatus () {
      if (this.focusStatus === true) {
        this.$refs.deviceScope.blur()
      }
    },
    radioType: {
      immediate: true,
      handler (val) {
        console.log(val)
        this.updateForm.sourceVersions = []
        this.updateForm.deviceList = []
        this.flag = false
        if (val === 1) {
          this.$refs.updateForm.clearValidate('deviceList')
        }
      }
    }
  },
  components: {
    Drawer,
    TextDialog,
    FileList
  },
  computed: {
    upgradeScopeOptions () {
      if (this.updateForm.strategyType === 0) {
        return [
          {
            label: '全部设备',
            value: 0 // 0
          },
          {
            label: '定向升级',
            value: 1 // 1  TODO: 需做判断处理
          }
        ]
      } else {
        return [
          {
            label: '全部设备',
            value: 0 // 0
          }
        ]
      }
    },
    upgradeTimeTypeOptions () {
      if (this.updateForm.strategyType === 0) {
        return [
          {
            label: '立即升级',
            value: 0 // 0
          },
          {
            label: '定时升级',
            value: 1 // 1  TODO: 需做判断处理
          }
        ]
      } else {
        return [
          {
            label: '立即升级',
            value: 0 // 0
          }
        ]
      }
    }
  },
  created () {
    // 解决select设置多选(multiple) 触发formItem校验
    this.$set(this.updateForm, 'sourceVersions', [])
    this.$set(this.updateForm, 'deviceList', [])
    console.log(this.rows)
    const params = {
      params: {
        productKey: this.rows.productKey,
        moduleName: this.rows.module
      }
    }
    getVersions(params).then(res => {
      this.updateForm.sourceVersions = []
      // 过滤自身的本版
      let versions = res.data.data;
      let currentVerion = this.rows;
      let filterVersion = versions.filter(item => {
        if (item.moduleVersion != currentVerion.destVersion) {
          return item
        }
      });

      this.sourceVersionsOptions = filterVersion;
      if (this.rows.firmwareType === 1) {
        this.updateForm.sourceVersions.push(this.rows.sourceVersion)
      }
    })
  },
  methods: {
    strategyTypeChange(e) {
      if (e == 1) {
        this.$set(this.updateForm, 'upgradeScope', 0);
      }
    },
    upgradeScopeChange(e) {
    },
    // 文件验证
    file (rule, value, callback) {
      if (this.flag === false) {
        return callback(new Error('请上传文件'))
      } else {
        callback()
      }
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
      this.focusStatus = true
    },
    getArrDifference (arr1, arr2) { // 去除相差的那个数
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    },
    cancle (val) {
      this.$emit('closeBatchDialog')
      if (val === 1) {
        this.$emit('reflash')
      }
    },
    openDrawer () {
      this.drawerFlag = true
      // this.$refs.drawer.drawerFlag = true
      this.$refs.deviceScope.blur()
      this.focusStatus = false
      // this.$refs.deviceScope.blur()
      // document.getElementsByClassName('el-select__input')[0].blur()
      // this.$refs.drawer.getList()
      this.ids = this.deviceListOptions
    },
    versionChange (val) {
      console.log(val)
      // this.$refs.drawer.versionValue = val
    },
    getChildData (val) {
      console.log('val', val)
      console.log([...new Set(val.version)])
      val.version.sort()
      const deviceNameList = []
      val.deviceList.forEach(element => {
        deviceNameList.push(element.deviceName)
      })
      this.deviceListOptions = val.deviceList
      this.updateForm.deviceList = deviceNameList
      this.updateForm.sourceVersions = [...new Set(val.version)]
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 验证成功
          // const params = Object.assign({}, this.updateForm)
          const params = {
            params: {
              batchType: 1,
              strategyType: this.updateForm.strategyType,
              upgradeScope: this.updateForm.upgradeScope,
              upgradeTimeType: this.updateForm.upgradeTimeType,
              firmwareId: this.rows.firmwareId,
              // deviceList: this.deviceListOptions.length > 0 ? this.deviceListOptions : [],
              sourceVersions: this.updateForm.sourceVersions,
              upgradeTime: this.updateForm.upgradeTime ? this.updateForm.upgradeTime : '',
              upgradeTimeout: this.updateForm.upgradeTimeout,
              isForceUpgrade: this.updateForm.isForceUpgrade
            }
          }
          // 对批量上传数据进行处理
          console.log(this.deviceDetail)
          if (this.radioType === 0) {
            this.deviceListOptions.length > 0 ? params.params.deviceList = this.deviceListOptions : params.params.deviceList = []
          } else {
            const deviceList = Object.assign([], this.deviceDetail)
            deviceList.forEach((e) => {
              delete e.id
              delete e.moduleName
            })
            // console.log('sadsa', deviceList, this.deviceDetail)
            params.params.deviceList = this.deviceDetail
          }
          add(params).then(res => {
            if (res.data.code === 200) {
              // this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: res.data.message || res.message
              })
              this.cancle(1)
            } else {
              this.$message({
                type: 'error',
                message: res.data.message || res.message
              })
              this.cancle()
            }
          })
        }
      })
    },
    // 置空
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 文件上传
    handleChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    handleRemove (file, fileList) {
      this.flag = false
    },
    beforeUpload (file) {
      /* const name = file.name
      const type = name.substring(name.lastIndexOf('.') + 1)
      if (type !== 'xsl') {
        this.$message.error('请上传json文件格式')
        return false
      } */
      if (file.size > 1024 * 1024) {
        this.$message.error('文件大小超过1M请重试')
        return false
      }
    },
    fileRequest (item) {
      const formData = new FormData()
      formData.append('file', item.file)
      formData.append('module', this.rows.module)
      formData.append('productKey', this.rows.productKey)
      formData.append('id', uuidv4())
      formData.append('timestamp', Date.parse(new Date()))
      formData.append('version', '1.0')
      importFile(formData)
        .then(res => {
          if (res.data.code === 200) {
            this.flag = true
            this.$refs.updateForm.validateField('file')
            const result = res.data.data
            console.log(result)
            if (result.illegalDataList.length > 0 || result.notExistDeviceList.length > 0 || result.notReportVersionDeviceList.length > 0) {
              this.$message.warning('文件上传成功，部分设备上传时出现问题,请查看')
            } else {
              this.$message.success('上传文件成功')
            }
            this.deviceDetail = result.deviceList
            // 将版本号赋值,并进行去重  moduleVersion
            const sourceVersions = []
            this.deviceDetail.forEach((e) => {
              sourceVersions.push(e.moduleVersion)
            })
            this.updateForm.sourceVersions = [...new Set(sourceVersions)]
            delete result.deviceList
            this.textDesc = result
          } else {
            this.flag = false
            this.$message.error(res.data.message)
          }
        })
    },
    handlerClick (val) {
      val === 'text' ? this.textDialog = true : this.fileListDialog = true
    }
  }
}
</script>

<style lang='less' scoped>
  /deep/ .el-tag__close{
    display: none
  }
  .text{
    color: #409EFF;
    .el-col{
      cursor: pointer;
    }
  }
</style>
